<script lang="ts">
    import {getLogger} from 'src/core';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import {exists} from 'shared/utils/custom-utils';

    export let embedUrl: string;

    const logger = getLogger();

    let iframeContentLoading = true;

    const handleIframeLoaded = (event: Event) => {
        const iframe = event.target as HTMLIFrameElement;

        try {
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

            // Arbitrary timeout just in case - let Metabase embed load fully
            setTimeout(() => {
                injectCustomStyling(iframeDocument);
                iframeContentLoading = false;
            }, 500);
        } catch (e) {
            logger.error('Cannot inject custom styling to Metabase iframe', e);
            iframeContentLoading = false;
        }
    };

    function injectCustomStyling(iframeDocument: Document) {
        // Hide Metabase attributions footer - just test, we'll add another form of attribution later
        const footerToHide = iframeDocument.querySelector('footer');
        if (exists(footerToHide)) {
            footerToHide.style.display = 'none';
        }
    }
</script>


<div class="analytics-embed-container">
    {#if iframeContentLoading}
        <div class="loading-container">
            <KpLoadingBlock/>
        </div>
    {/if}

    <iframe
            class:iframe-loading={iframeContentLoading}
            title="Analytics embed"
            src={embedUrl}
            allowTransparency
            on:load={handleIframeLoaded}
    />
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro-erp.less";

    .analytics-embed-container {
        .flex-grow();
        position: relative;

        .loading-container {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        iframe {
            .flex-grow();

            border: none;
            position: relative;
            background-color: @themed-body-bg;
            width: 100%;
            transition: opacity 0.3s ease-in-out;

            &.iframe-loading {
                opacity: 0;
            }
        }
    }
</style>